export const PRODUCT_SEARCH_FILTERS = [
  { key: 'rahmen', label: 'Rahmen', articleIds: [1] },
  { key: 'drehtueren', label: 'Drehtüren', articleIds: [2, 3] },
  { key: 'schiebetueren', label: 'Schiebetüren', articleIds: [4, 5, 7, 8, 10, 11] },
  { key: 'stulptueren', label: 'Stulptüren', articleIds: [13, 14] },
  { key: 'zargentueren', label: 'Zargentüren', articleIds: [15] },
  { key: 'pendeltueren', label: 'Pendeltüren', articleIds: [16] },
  { key: 'fenster_rollo', label: 'Fenster Rollo', articleIds: [17, 18] },
  { key: 'lisa', label: 'LISA', articleIds: [21, 22, 23, 24] },
  { key: 'p_rollo', label: 'P-Rollo', articleIds: [28] },
  { key: 'p20_fenster', label: 'P20 Fenster', articleIds: [25] },
  { key: 'p20_tueren', label: 'P20 Türen', articleIds: [29, 30] },
  { key: 'p45', label: 'P45', articleIds: [26, 27] },
];
